const NAME_FORMAT = /^[A-Za-z][A-Za-z0-9_]*$/;
// The longest name a Baton `<scope>.secret.<name>` reference can carry.
const MAX_NAME_LENGTH = 64;

export const PYPESTREAM_PREFIX = 'pypestream_';

export type SecretNameError = 'format' | 'tooLong' | 'reserved';

export const hasPypestreamPrefix = (name: string) =>
  name.toLowerCase().startsWith(PYPESTREAM_PREFIX);

/**
 * `Secret.create_changeset/2` and `Secrets.Naming`'s name rules, checked as the user types. An
 * empty name is not an error until submit, so an untouched field does not open red. Uniqueness
 * needs every reachable scope, so only the server checks it.
 */
export function secretNameError(
  name: string,
  { allowPypestreamPrefix = false }: { allowPypestreamPrefix?: boolean } = {}
): SecretNameError | null {
  if (name === '') return null;
  if (name.length > MAX_NAME_LENGTH) return 'tooLong';
  if (!NAME_FORMAT.test(name)) return 'format';
  if (!allowPypestreamPrefix && hasPypestreamPrefix(name)) return 'reserved';
  return null;
}
